var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypePlayCircleSizelWeightoutlined = function SvgTypePlayCircleSizelWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3m0 24a11 11 0 1 1 11-11 11.01 11.01 0 0 1-11 11m6.03-11.847-8-5A1 1 0 0 0 12.5 11v10a1 1 0 0 0 1.53.848l8-5a1 1 0 0 0 0-1.695m-7.53 4.043v-6.392L19.614 16z"
  })));
};
export default SvgTypePlayCircleSizelWeightoutlined;